import styled from 'styled-components';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td
} from 'react-super-responsive-table';

// Styled wrappers around react-super-responsive-table primitives so the
// variable-column IoT tables stay responsive without page-level horizontal
// scroll (Constitution §8) while reusing the existing IoT table look
// (modelled on ratePlans/components/css.js).

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export const StyledTable = styled(Table)`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1rem;
`;

export const StyledThead = styled(Thead)`
  background: #4b286d;
`;

export const StyledTbody = styled(Tbody)``;

export const StyledTr = styled(Tr)`
  border: 1px solid #e3e3e3;
`;

export const StyledTh = styled(Th)`
  text-align: center;
  background: #4b286d;
  color: #fff;
  font-weight: 700;
  font-size: 13px;
  padding: 0.5rem;
  border: 1px solid #e3e3e3;
`;

export const StyledTd = styled(Td)`
  border: 1px solid #e3e3e3;
  text-align: center;
  font-size: 13px;
  color: #565656;
  padding: 0.5rem;
`;

export const GroupTd = styled(StyledTd)`
  background: #f7f7f7;
  font-weight: 700;
`;

export const ChildName = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
`;

export const QuantityInput = styled.input`
  box-sizing: border-box;
  width: 4rem;
  height: 2.25rem;
  text-align: center;
  padding: 0.25rem;
  border: 1px solid #e3e3e3;
`;

// Native <select> for the Term column — replaces @tds/core-select so the
// control height can be set directly and kept identical to QuantityInput.
export const TermSelect = styled.select`
  box-sizing: border-box;
  display: block;
  width: 100%;
  max-width: 12rem;
  height: 2.25rem;
  margin: 0 auto;
  padding: 0.25rem 0.5rem;
  font-size: 13px;
  color: #565656;
  border: 1px solid #e3e3e3;
  background: #fff;
`;
